import React from 'react'
import styles from './AboutUsPage.module.scss'
import { ReactComponent as TargetIcon } from '../../../../assets/icons/about/target.svg'
import { ReactComponent as ShieldIcon } from '../../../../assets/icons/about/shield.svg'
import { ReactComponent as BoltIcon } from '../../../../assets/icons/about/bolt.svg'
import { ReactComponent as GlobeIcon } from '../../../../assets/icons/about/globe.svg'
import { ReactComponent as CodeIcon } from '../../../../assets/icons/about/code.svg'
import { ReactComponent as PaletteIcon } from '../../../../assets/icons/about/palette.svg'
import { ReactComponent as HeadsetIcon } from '../../../../assets/icons/about/headset.svg'

const AboutUsPage = ({ goBack }) => {
  const values = [
    {
      icon: 'target',
      title: 'Инновации',
      description: 'Мы постоянно развиваемся и внедряем передовые технологии для создания лучших решений'
    },
    {
      icon: 'shield',
      title: 'Надежность',
      description: 'Наши клиенты могут положиться на стабильность и безопасность наших сервисов'
    },
    {
      icon: 'bolt',
      title: 'Скорость',
      description: 'Быстрая разработка и молниеносная работа всех наших платформ'
    },
    {
      icon: 'globe',
      title: 'Доступность',
      description: 'Наши сервисы доступны 24/7 из любой точки мира'
    }
  ]

  const services = [
    {
      category: 'E-commerce',
      items: ['Интернет-магазин', 'Доставка еды'],
      description: 'Полнофункциональные решения для онлайн-торговли с удобным интерфейсом и быстрой обработкой заказов'
    },
    {
      category: 'Технологии',
      items: ['IT услуги', 'Игровые серверы'],
      description: 'Профессиональные IT-решения и высокопроизводительные игровые серверы для вашего бизнеса'
    },
    {
      category: 'Социальные платформы',
      items: ['Сообщество', 'Мероприятия'],
      description: 'Объединяем людей через современные социальные платформы и организацию событий'
    },
    {
      category: 'Развлечения',
      items: ['Фильмы', 'Аниме', 'Медиа'],
      description: 'Обширные базы контента с удобной системой поиска и рекомендаций'
    },
    {
      category: 'Путешествия',
      items: ['Туризм'],
      description: 'Планирование и бронирование туров с лучшими предложениями'
    }
  ]

  const stats = [
    { number: '10+', label: 'Сервисов' },
    { number: '24/7', label: 'Поддержка' },
    { number: '1000+', label: 'Пользователей' },
    { number: '99.9%', label: 'Uptime' }
  ]

  const team = [
    {
      role: 'Разработка',
      description: 'Команда опытных разработчиков создает надежные и масштабируемые решения',
      icon: 'code'
    },
    {
      role: 'Дизайн',
      description: 'Креативные дизайнеры создают современный и интуитивный интерфейс',
      icon: 'palette'
    },
    {
      role: 'Поддержка',
      description: 'Профессиональная команда поддержки всегда готова помочь',
      icon: 'headset'
    }
  ]

  const getIcon = (iconName) => {
    const icons = {
      target: TargetIcon,
      shield: ShieldIcon,
      bolt: BoltIcon,
      globe: GlobeIcon,
      code: CodeIcon,
      palette: PaletteIcon,
      headset: HeadsetIcon
    }
    const Icon = icons[iconName]
    return Icon ? <Icon className={styles.icon} /> : null
  }

  return (
    <div className={styles.page}>
      <div className={styles.heroSection}>
        <div className={styles.heroContent}>
          <h1 className={styles.heroTitle}>
            <span className={styles.gradient}>NCORE</span> - Nomad Core
          </h1>
          <p className={styles.heroSubtitle}>
            Ядро инноваций для цифровых кочевников
          </p>
        </div>
      </div>

      <div className={styles.statsSection}>
        <div className={styles.statsGrid}>
          {stats.map((stat, index) => (
            <div key={index} className={styles.statCard}>
              <div className={styles.statNumber}>{stat.number}</div>
              <div className={styles.statLabel}>{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      <div className={styles.missionSection}>
        <h2 className={styles.sectionTitle}>Наша миссия</h2>
        <div className={styles.missionContent}>
          <div className={styles.missionText}>
            <h3>N - Nomad (Кочевник)</h3>
            <p>
              Мы верим в свободу выбора и мобильность. Как цифровые кочевники современности, мы создаем сервисы, 
              которые следуют за вами везде, где бы вы ни находились. Наши решения адаптируются к вашему образу жизни, 
              предоставляя полный функционал в любое время и в любом месте.
            </p>
          </div>
          <div className={styles.missionText}>
            <h3>Core (Ядро)</h3>
            <p>
              NCORE - это ядро, фундамент вашей цифровой жизни. Мы объединяем все необходимые сервисы в одной 
              экосистеме: от покупок и развлечений до профессиональных IT-решений. Централизованная платформа 
              с децентрализованными возможностями - вот наша философия.
            </p>
          </div>
        </div>
      </div>

      <div className={styles.valuesSection}>
        <h2 className={styles.sectionTitle}>Наши ценности</h2>
        <div className={styles.valuesGrid}>
          {values.map((value, index) => (
            <div key={index} className={styles.valueCard}>
              <div className={styles.valueIcon}>{getIcon(value.icon)}</div>
              <h3 className={styles.valueTitle}>{value.title}</h3>
              <p className={styles.valueDescription}>{value.description}</p>
            </div>
          ))}
        </div>
      </div>

      <div className={styles.servicesSection}>
        <h2 className={styles.sectionTitle}>Что мы предлагаем</h2>
        <div className={styles.servicesGrid}>
          {services.map((service, index) => (
            <div key={index} className={styles.serviceCard}>
              <div className={styles.serviceHeader}>
                <h3>{service.category}</h3>
                <div className={styles.serviceItems}>
                  {service.items.map((item, idx) => (
                    <span key={idx} className={styles.serviceTag}>{item}</span>
                  ))}
                </div>
              </div>
              <p className={styles.serviceDescription}>{service.description}</p>
            </div>
          ))}
        </div>
      </div>

      <div className={styles.teamSection}>
        <h2 className={styles.sectionTitle}>Наша команда</h2>
        <p className={styles.teamIntro}>
          Профессионалы, которые создают будущее
        </p>
        <div className={styles.teamGrid}>
          {team.map((member, index) => (
            <div key={index} className={styles.teamCard}>
              <div className={styles.teamIcon}>{getIcon(member.icon)}</div>
              <h3 className={styles.teamRole}>{member.role}</h3>
              <p className={styles.teamDescription}>{member.description}</p>
            </div>
          ))}
        </div>
      </div>


    </div>
  )
}

export default AboutUsPage
